export const APP_REFRESH_ID = 'finance_app_refresh_id';
